import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Box } from '@mui/material';
import React from 'react';
import { SidebarAccordion } from 'src/components/accordion';
import { Drawer } from 'src/components/drawer';
import { SidebarHeader } from 'src/components/header';
import { ProductsSidebar } from 'src/components/productsSidebar';
import { ComponentTypes } from 'src/interfaces';

import { EditLOVProductsProps } from '../OOEditProducts.interface';
import {
  EditProductsWrapper,
  SidebarContainer,
  SidebarContent,
} from '../OOEditProducts.styled';
import { OOLovEditVisualsComponent } from './LOVEditVisuals';

export const OOLovEditProductsComponent = (props: EditLOVProductsProps) => {
  const [openImageSelectionDrawer, setOpenImageSelectionDrawer] =
    React.useState(false);
  const [openProductsDrawer, setOpenProductsDrawer] = React.useState(false);
  const [isDefaultImageSourceUpdated, setIsDefaultImageSourceUpdated] =
    React.useState<boolean | undefined>();

  const LOVitems = [
    {
      label: 'Products',
      onLabelClick: () => setOpenProductsDrawer(!openProductsDrawer),
      content: <div />,
      chevronIcon: <NavigateNextIcon />,
      disabledExpand: true,
      hasError: false,
    },

    // NOTE: Disables the Image Selection for Product Overrides.

    // {
    //   label: 'Image selection',
    //   content: <div />,
    //   onLabelClick: () => {
    //     setIsDefaultImageSourceUpdated(false);
    //     setOpenImageSelectionDrawer(!openImageSelectionDrawer);
    //   },
    //   chevronIcon: <NavigateNextIcon />,
    //   disabledExpand: true,
    //   hasError: false,
    // },
  ];

  return (
    <Box>
      <EditProductsWrapper>
        <SidebarContent>
          <SidebarAccordion items={LOVitems} />
        </SidebarContent>
      </EditProductsWrapper>
      <Drawer open={openProductsDrawer}>
        <SidebarContainer>
          <SidebarHeader
            label="Products"
            onBackClick={() => setOpenProductsDrawer(false)}
          />
          <SidebarContent>
            <ProductsSidebar
              componentType={ComponentTypes.LISTING_WITH_OPTIONAL_VISUALS}
              componentConfig={props.selectedComponent?.config}
              onBackClick={() => setOpenProductsDrawer(false)}
              onChangedComponentConfigField={props.onOverrideConfig}
              productCategoryIDs={props.selectedComponent?.product_category_id}
              themeId={
                props.selectedComponent?.theme_id ||
                props.selectedComponent?.config?.themeId
              }
            />
          </SidebarContent>
        </SidebarContainer>
      </Drawer>
      <Drawer open={openImageSelectionDrawer}>
        <SidebarContainer>
          <SidebarHeader
            label="Image selection"
            onBackClick={() => setOpenImageSelectionDrawer(false)}
          />
          <SidebarContent>
            <OOLovEditVisualsComponent
              onOverrideConfig={props.onOverrideConfig}
              selectedComponent={props.selectedComponent}
              onDefaultImageSourceUpdated={(val) =>
                setIsDefaultImageSourceUpdated(val)
              }
              isDefaultImageSourceUpdated={isDefaultImageSourceUpdated}
            />
          </SidebarContent>
        </SidebarContainer>
      </Drawer>
    </Box>
  );
};
